import { SHOW_LOADING_OVERLAY, HIDE_LOADING_OVERLAY } from '../types'

export const showLoadingOverlay = () => ({
  type: SHOW_LOADING_OVERLAY
})

export const hideLoadingOverlay = () => ({
  type: HIDE_LOADING_OVERLAY
})
